export default {
explore_by: "Erkunden Sie mit",
explore_by_concepts: "Ideen",
explore_by_families: "Duftfamilien",
language: "Sprache",
legal: "Rechtliches",
find_any_fragrance: "Finden Sie jeden Duft in der Welt.",
title_by_concepts: "Inspiriere mich / Erkunden durch Ideen",
desc_by_concepts: "Finden Sie Ihren Duft, indem Sie über Ihre Lieblingsfarbe oder Ihren Lieblingsort nachdenken",
title_by_families: "Duftfamilien entdecken",
desc_by_families: "Finden Sie Ihren Duft, indem Sie an ... denken",
expert_reviewed: "Expertenmeinung",
ingredients: "Zutaten",
description: "Beschreibung",
perfumist: "Parfümeur",
concepts: "Konzepte",
olfactive_family: "Olfactive Familie",
main_family: "Familie",
sub_family: "Unterfamilie",
me_family: "Düfte der Welt",
filter_by_family: "Familien",
filter_by_brand: "Marken",
filter_by_gender: "Für wen?",
for_him: "Für ihn",
for_her: "Für sie",
unisex: "Unisex",
all: "alle",
all_female: "alle",
concepts_list: "Liste der Konzepte",
no_results_for_this_combination: "Keine Parfums für diese Kombination gefunden.",
select_at_least_one_concept: "Wählen Sie mindestens ein Konzept aus",
view_perfumes: "Parfums ansehen",
back: "Zurück",
close: "Schliessen",
filters: "Filter",
selected_concepts: "Ausgewählte Konzepte:",
selected_families: "Ausgewählte Familien:",
find_concept: "Konzepte finden...",
smell_of: "Hauptduft",
touch_of: "Mit einer Note von",
loading_perfumes: "Parfums werden ausgewählt",
loading_concepts: "Konzepte werden zusammengestellt",
apply: "anwenden",
search: "suchen",
clear_all: "Alles löschen",
iconic_fragrances: "Ikonische Düfte in dieser Familie",
is_there_anybody_here: "Sind Sie noch da?",
continue_previous_session: "Ja! Lass uns weitermachen",
reset_session: "Neu starten",
ingredient_type: "Typ",
ingredient_parts: "Verwendete(s) Teil(e)",
ingredient_extraction: "Extraktionsverfahren",
ingredient_first: "Ikonisches Parfum",
history: "Geschichte",
effect: "Herstellung & Wirkung",
origin: "Herkunft",
iconic_fragrance: "Ikonischer Duft",
production: "Herstellung",
loyalty_become_a_member: "Treten Sie dem Club bei",
loyalty_avolta_link: "https://qr.clubavolta.com/register?source=ctOffline-scDuty_Free-sgAirport&campaign=Fragrance_Finder_Tools" 
}
